// removed by extract-text-webpack-plugin
module.exports = {"suggestItem":"_2yzTB","title":"F4Pv2","subtitle":"_1AWkf","suggestItemActive":"_3nToz"};


//////////////////
// WEBPACK FOOTER
// ./banquet/components/AddressSearch/SuggestItem/index.sass
// module id = 1455
// module chunks = 1